import { adapter, Service } from '../index';
import { A9DecoratorsCommon } from './A9DecoratorsCommon';

export interface IA9Service {
    name?: string;
    priority?: number;
}

export function A9Service(object?: IA9Service | string) {
    return function (service: any) {
        const injectorParams = A9DecoratorsCommon.parseConstructorParams(service);

        const parent = <typeof Service>service;

        class ChildService extends parent {
            public static injectorParams: string[] = [];
            public static get $name() {
                return (typeof object === 'string' && object) || (service.hasOwnProperty('$name') && service.$name) || service.name;
            }
            public static get $inject() {
                return ChildService.injectorParams;
            }
        }
        ChildService.injectorParams = injectorParams;
        adapter.linkService(<typeof service>ChildService);
        return <typeof service>ChildService;
    };
}
